import { render, staticRenderFns } from "./skeleton.vue?vue&type=template&id=cd4f89b2&"
import script from "../assets/js/skeleton.js?vue&type=script&lang=js&"
export * from "../assets/js/skeleton.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports